<template>
  <div class="wrap">
    <base-table
      :base-url="urlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @load-error="onLoadError"
      @refresh="onRefresh"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
          :data="items"
          stripe
          class="w-100"
          @sort-change="sortChange"
          :summary-method="getTotals"
          show-summary
        >
          <el-table-column type="expand" v-slot="{row: {listUrl}}">
            <expand-column :url="listUrl" :params="params"></expand-column>
          </el-table-column>
          <el-table-column
            prop="id"
            sortable
            label="Id"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="Representative"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="total_messages"
            label="Total messages"
            min-width="150"
            sortable
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
  </div>
</template>

<script>
import TableWithoutPagination from '../../components/table-without-pagination';
import {addQueryParams} from '../../libs/url';
import ExpandColumn from "./expand-column";

const orderTypeMap = {
  'descending': 'desc',
  'ascending': 'asc',
};

export default {
  extends: TableWithoutPagination,
  props: {
    params: Object,
  },

  components: {
    ExpandColumn,
  },

  data() {
    return {
      filters: {},
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, _.assign({}, this.filters, this.params));
    },
  },

  methods: {
    /**
     * @param {Object} column
     * @param {string} prop
     * @param {string} order
     * @return {undefined}
     */
    sortChange({column, prop, order}) {
      let orderType = _.get(orderTypeMap, order, null);

      this.filters = orderType
        ? _.assign({}, this.filters, {sort_by: _.last(_.split(prop, '.')), sort: orderType})
        : _.omit(this.filters, ['sort_by', 'sort'])
      ;
    },

    /**
     * @param {Array} columns
     * @param {Array} data
     * @return {Array}
     */
    getTotals({columns, data}) {
      const hasTotals = ['regular_messages', 'group_messages'];

      return _.chain(columns)
        .map(col => {
          if (col.property === 'id') {
            return 'Totals';
          }

          return _.includes(hasTotals, col.property)
            ? _.sumBy(data, col.property)
            : '';
        })
        .values()
        .value();
    },

    /**
     * @param {Array} items
     */
    onLoadSuccess({items}) {
      this.items = items;
      this.$emit('success');
    },

    /**
     * @param error
     * @emits validation-error
     */
    onLoadError({response: {status, data}}) {
      if (status === 422) {
        this.$emit('validation-error', data.errors || {});
      }
    },
  }
}
</script>
